module.exports = __webpack_public_path__ + "img/pinned-assets-icon-active.2bcef9b5.svg";